import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useEvents } from "@/hooks/useEvents";
import EventCard from "@/components/EventCard";

const RecentEvents = () => {
  const { data: events } = useEvents(3);

  if (!events || events.length === 0) return null;

  return (
    <section className="px-6 py-20 md:py-28">
      <div className="mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-12 text-center"
        >
          <span className="mb-4 block font-body text-sm uppercase tracking-[0.3em] text-secondary">
            Our Work
          </span>
          <h2 className="font-heading text-3xl font-bold text-foreground md:text-4xl">
            Recent VR Events
          </h2>
          <p className="mx-auto mt-4 max-w-lg font-body text-muted-foreground">
            A look at the activations, corporate events and immersive experiences we have delivered.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {events.map((e, i) => (
            <EventCard key={e.id} event={e} index={i} />
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/events"
            className="inline-flex items-center gap-2 font-heading text-sm font-semibold text-primary hover:opacity-80"
          >
            View All Events
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RecentEvents;
